import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            translation: {
                'modal-languages': {
                    title: 'Choose your language',
                    subTitle: 'Languages:',
                    actualLan: 'Current language ',
                },
                'modal-lose': {
                    contentLabel: 'Lose Modal',
                    title: "¡You don't have any more lives!",
                    subTitle: "We'll be waiting for you tomorrow",
                    span: "Surely you'll make it"
                },
                'modal-solution': {
                    subTitlePl: 'possible solutions:',
                    subTitleSin: 'possible solution:'
                },
                'modal-win': {
                    title: '¡Good game!',
                    subTitle: "¡You've completed the board!",
                    streak: 'Streak: ',
                    day: ' day',
                    days: ' days',
                    lives: 'Live: '
                },
                'input-suggestion': {
                    placeholder: 'Write the name of a champion...',
                    spanLose: 'Come back tomorrow for a new board',
                    spanWin: 'Come back tomorrow to continue your streak',
                    spanStart: 'Select an empty square to continue playing',
                    spanStartEmpty: 'Select an empty square to start playing',
                },
                'suggested': {
                    spanNothing: 'No champion found with this name...',
                },
                'iconImg': {
                    name: "English",
                    icon: "us",
                    lang: "¡We will add more languages ​​soon!"
                },
                'modal-play': {
                    title: "¿How to play LoLBoard?",
                    first: "LoLBoard features clues in the first row and column of the board, which may pertain to faction, role, species, or release year of League of Legends champions.",
                    second: "To play, select an empty square by clicking on it. A text box will reveal itself, and you'll need to guess the League of Legends champion using the clues from the respective row and column related to the selected square.",
                    lives: "You have 1000HP to complete the board. Each time you fail to guess a champion, you'll lose 100HP. Remember that champions can be repeated in different squares.",
                    finished: "Upon finishing the game, you'll have the option to click on each square to discover all possible solutions for that square. Remember, there will be a new board every day!",
                    lolboard: "¡Have fun on LoLBoard!"
                },
                'footer': {
                    description: "Feel free to reach out to me on Twitter with any feedback, bugs, or other inquiries!",
                }
            },
        },
        es: {
            translation: {
                'modal-languages': {
                    title: 'Elige tu idioma',
                    subTitle: 'Idiomas:',
                    actualLan: 'Idioma actual ',
                },
                'modal-lose': {
                    contentLabel: 'Derrota Modal',
                    title: '¡No tienes más vidas!',
                    subTitle: 'Estaremos esperándote mañana',
                    span: 'Seguro que lo lograrás'
                },
                'modal-solution': {
                    subTitlePl: 'posibles soluciones:',
                    subTitleSin: 'posible solución:'
                },
                'modal-win': {
                    title: '¡Bien jugado!',
                    subTitle: '¡Has completado el tablero!',
                    streak: 'Racha: ',
                    day: ' día',
                    days: ' días',
                    lives: 'Vida: '
                },
                'input-suggestion': {
                    placeholder: 'Escribe el nombre de un campeón...',
                    spanLose: 'Vuelve mañana para un nuevo tablero',
                    spanWin: 'Vuelve mañana para continuar tu racha',
                    spanStart: 'Selecciona una casilla para seguir jugando',
                    spanStartEmpty: 'Selecciona una casilla vacía para jugar',
                },
                'suggested': {
                    spanNothing: 'Ningún campeón con este nombre...',
                },
                'iconImg': {
                    name: "Español",
                    icon: "es",
                    lang: "¡Añadiremos más idiomas pronto!"
                },
                'modal-play': {
                    title: "¿Cómo jugar a LoLBoard?",
                    first: "LoLBoard presenta pistas en la primera fila y columna del tablero, las cuales pueden referirse a facción, rol, especie o año de lanzamiento de los campeones de League of Legends.",
                    second: "Para jugar, selecciona un cuadrado vacío haciendo clic en él. Se revelará un cuadro de texto, y deberás adivinar al campeón de League of Legends utilizando las pistas de la fila y columna respectivas relacionadas con el cuadrado seleccionado.",
                    lives: "Dispones de 1000HP para completar el tablero. Cada vez que no aciertes al adivinar un campeón, perderás 100. Recuerda que se pueden repetir campeones en distintos cuadrados.",
                    finished: "Al finalizar el juego, tendrás la opción de hacer click en cada cuadrado para descubrir todas las posibles soluciones para ese cuadrado. ¡Recuerda, habrá un nuevo tablero todos los días!",
                    lolboard: "¡Diviértete en LoLBoard!"
                },
                'footer': {
                    description: "No dudes en comunicarte conmigo en Twitter con cualquier comentario, error u otras consultas!",
                }           
            },
        },
        pt: {
            translation: {
                'modal-languages': {
                    title: 'Escolha o seu idioma',
                    subTitle: 'Idiomas:',
                    actualLan: 'Idioma atual ',
                },
                'modal-lose': {
                    contentLabel: 'Derrota Modal',
                    title: 'Você não tem mais vidas!',
                    subTitle: 'Estaremos esperando por você amanhã',
                    span: 'Certamente você conseguirá'
                },
                'modal-solution': {
                    subTitlePl: 'possíveis soluções:',
                    subTitleSin: 'possível solução:'
                },
                'modal-win': {
                    title: 'Bom jogo!',
                    subTitle: 'Você completou o tabuleiro!',
                    streak: 'Sequência: ',
                    day: ' dia',
                    days: ' dias',
                    lives: 'Vidas: '
                },
                'input-suggestion': {
                    placeholder: 'Escreva o nome de um campeão...',
                    spanLose: 'Volte amanhã para um novo tabuleiro',
                    spanWin: 'Volte amanhã para continuar sua sequência',
                    spanStart: 'Selecione uma casa para continuar jogando',
                    spanStartEmpty: 'Selecione uma casa vazia para começar',
                },
                'suggested': {
                    spanNothing: 'Nenhum campeão encontrado com esse nome...',
                },
                'iconImg': {
                    name: "Português",
                    icon: "pt",
                    lang: "¡Vamos adicionar idiomas em breve!"
                },
                'modal-play': {
                    title: "¿Como jogar LoLBoard?",
                    first: "O LoLBoard apresenta pistas na primeira fila e coluna do tabuleiro, as quais podem se referir a facção, papel, espécie ou ano de lançamento dos campeões do League of Legends.",
                    second: "Para jogar, selecione um quadrado vazio clicando nele. Uma caixa de texto será revelada, e você precisará adivinhar o campeão do League of Legends usando as pistas da linha e coluna respectivas relacionadas ao quadrado selecionado.",
                    lives: "Você tem 8 vidas para completar o tabuleiro. Cada vez que falhar em adivinhar um campeão, perderá uma vida.",
                    finished: "Ao finalizar o jogo, você terá a opção de clicar em cada quadrado para descobrir todas as possíveis soluções para esse quadrado. Lembre-se, haverá um novo tabuleiro todos os dias!",
                    lolboard: "¡Divirta-se no LoLBoard!"
                },
                'footer': {
                    description: "Feel free to reach out to me on Twitter with any feedback, bugs, or other inquiries!",
                }           
            },
        },
    },
});

export default i18n;
